import { render, staticRenderFns } from "./ReminderReport.vue?vue&type=template&id=582b6886&scoped=true&"
import script from "./ReminderReport.vue?vue&type=script&lang=js&"
export * from "./ReminderReport.vue?vue&type=script&lang=js&"
import style0 from "./ReminderReport.vue?vue&type=style&index=0&id=582b6886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b6886",
  null
  
)

export default component.exports